import { handleResponseV2, makeGet, makePut } from '@/redux/api/helpers';
import { HouseBillingCurrency } from '@/redux/modules/billingManagement/houseBillingCurrency/houseBillingCurrency.types';

type GetHouseBillingCurrencyOptionsParams = {
    authToken: string;
    deployment: string;
};

type GetHouseBillingCurrencyOptionsResponse = {
    error: boolean;
    payload: HouseBillingCurrency[];
};

export const getHouseBillingCurrencyOptions = ({ authToken, deployment }: GetHouseBillingCurrencyOptionsParams) =>
    new Promise<GetHouseBillingCurrencyOptionsResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'admin/billing/currencies',
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

type PutHouseBillingCurrencyParams = {
    authToken: string;
    currency: HouseBillingCurrency['code'];
    deployment: string;
    houseId: number;
};

type PutHouseBillingCurrencyResponse = {
    error: boolean;
    payload: {
        currency: HouseBillingCurrency['code'];
        houseId: number;
    };
};

export const putHouseBillingCurrency = ({ authToken, deployment, houseId, ...body }: PutHouseBillingCurrencyParams) =>
    new Promise<PutHouseBillingCurrencyResponse>((resolve, reject) => {
        const request = makePut({
            apiPath: `admin/house/${houseId}/billing/currency`,
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });
        request.send(body);
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
